import fetchPost,  {fetchGet, fetchPostFormData } from '@/api/http.js'
export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        submitDraft({ commit }, data) {
            // 提交草稿
            return fetchPostFormData('/saas/customer/submitDraft', data)
            // return fetchPostFormData('http://100.118.210.55:9999/tbp-order-owner-saas-web/saas/customer/submitDraft', data)
        },
        submitVerify({ commit }, data) {
            // 提交审核
            return fetchPostFormData('/saas/customer/submitVerify', data)
            // return fetchPostFormData('http://100.118.210.55:9999/tbp-order-owner-saas-web/saas/customer/submitVerify', data)
        },
        queryByCustomerNoAPI({ commit }, data) {
            // 查询货主信息
            return fetchPost('/saas/customer/queryByCustomerNo', data)
            // return fetchPost('http://100.118.210.55:9999/tbp-order-owner-saas-web/saas/customer/queryByCustomerNo', data)
        },
        queryAllMentorConpany({ commit }, data) {
           //查询所有的客户信息
            return fetchPost('/saas/customer/queryAllMentorConpany', data)
            // return fetchPost('http://100.118.210.55:9999/tbp-order-owner-saas-web/saas/customer/queryAllMentorConpany', data)
        },
        listAllCitys({ commit }, data) {
            //查询所有的城市
             return fetchGet('/saas/customer/queryListAllCitys', data)
         },
         queryBankAccountApi({ commit }, data) {
            //查询所有的城市
             return fetchPost('/saas/customer/queryBankAccount', data)
         },
    }
}